import { useEffect, useState } from "react";

const CURRENT_VERSION = "1.0.1";
const VERSION_KEY = "rq_app_version";

export default function UpdateBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if service worker has an update waiting
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.ready.then((reg) => {
        // Check for updates every time the app loads
        reg.update().catch(() => {});

        // Listen for new service worker waiting
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              setShowBanner(true);
            }
          });
        });
      });
    }

    // Also check stored version
    try {
      const stored = localStorage.getItem(VERSION_KEY);
      if (stored && stored !== CURRENT_VERSION) {
        setShowBanner(true);
      }
      localStorage.setItem(VERSION_KEY, CURRENT_VERSION);
    } catch {}
  }, []);

  function handleUpdate() {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.ready.then((reg) => {
        if (reg.waiting) {
          reg.waiting.postMessage({ type: "SKIP_WAITING" });
        }
      });
    }
    window.location.reload();
  }

  if (!showBanner) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        background: "var(--dark)",
        borderTop: "2px solid #FF8A00",
        padding: "14px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        boxShadow: "0 -4px 20px rgba(0,0,0,0.3)",
      }}
    >
      <div style={{ flex: 1 }}>
        <div style={{ color: "#fff", fontWeight: 700, fontSize: "0.9rem" }}>
          Update available
        </div>
        <div style={{ color: "rgba(255,255,255,0.6)", fontSize: "0.8rem", marginTop: "2px" }}>
          Tap to get the latest features and fixes.
        </div>
      </div>
      <button
        type="button"
        onClick={handleUpdate}
        style={{
          background: "var(--primary)",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          padding: "10px 20px",
          fontSize: "0.85rem",
          fontWeight: 700,
          cursor: "pointer",
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
      >
        Update now
      </button>
      <button
        type="button"
        onClick={() => setShowBanner(false)}
        style={{
          background: "none",
          border: "none",
          color: "rgba(255,255,255,0.4)",
          fontSize: "1.2rem",
          cursor: "pointer",
          padding: "4px",
          lineHeight: 1,
          flexShrink: 0,
        }}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
